import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { router } from "./app/router";
import { UpdatePrompt } from "./components/UpdatePrompt";
import { startOfflineSync } from "./lib/offlineSync";
import { startInstallCapture } from "./lib/installPrompt";
import { refreshPacksOnWifi } from "./lib/packAutoUpdate";
import { initErrorTracking } from "./lib/errorTracking";
import { captureAttribution } from "./lib/attribution";
import "./styles/index.css";

/* Error tracking, when a DSN is configured. Never blocks the first render. */
void initErrorTracking();

/* Where this visitor came from (utm tags, ad click IDs), kept until they sign up. */
captureAttribution();

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

/**
 * Top-level wrapper.
 *
 * `UpdatePrompt` lives outside the router so it survives route transitions.
 * It registers the service worker, watches for updates, and shows a toast
 * when a new version is ready. The student taps "Update now" → the page
 * reloads with the latest code.
 */
function App() {
  return (
    <>
      <RouterProvider router={router} />
      <UpdatePrompt />
    </>
  );
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/*
 * Answers given with no network go out the moment there is one — including the
 * case where the tab was closed offline and reopened online, which fires no
 * `online` event.
 */
startOfflineSync();

/* The browser offers its install prompt once, early — catch it before Home asks. */
startInstallCapture();

/* "Keep my subjects updated on Wi-Fi": refresh stale packs, on Wi-Fi only. */
void refreshPacksOnWifi();
